import { Action } from '@ngrx/store';
import { MarketView, Markets } from '../../models/markets';
import { PayloadAction } from '@ipreo/muni-shared';

const SELECTED_MARKET_CHANGED = '[marketDrawer] Selected Market Changed';
const MARKETS_LOAD_REQUESTED = '[marketDrawer] Fetch Markets';
const MARKETS_LOAD_SUCCESS = '[marketDrawer] Fetch Markets Success';
const MARKETS_LOAD_FAILURE = '[marketDrawer] Fetch Markets Error';

/* tslint:disable:max-classes-per-file */
/* tslint:disable:no-null-keyword */
class SelectedMarketChangedAction implements PayloadAction<MarketView> {
  public readonly type = SELECTED_MARKET_CHANGED;

  constructor(public payload: MarketView) {}
}

class MarketsLoadAction implements Action {
  public readonly type = MARKETS_LOAD_REQUESTED;
  public readonly payload: null = null;
}

class MarketsLoadSuccessAction implements PayloadAction<Markets> {
  public readonly type = MARKETS_LOAD_SUCCESS;

  constructor(public payload: Markets) {}
}

class MarketsLoadErrorAction implements PayloadAction<string> {
  public readonly type = MARKETS_LOAD_FAILURE;

  constructor(public payload: string) {}
}

export {
  SelectedMarketChangedAction,
  MarketsLoadAction,
  MarketsLoadSuccessAction,
  MarketsLoadErrorAction,
  SELECTED_MARKET_CHANGED,
  MARKETS_LOAD_REQUESTED,
  MARKETS_LOAD_SUCCESS,
  MARKETS_LOAD_FAILURE
};
